module.exports = __webpack_public_path__ + "media/images/icons/country_flags/tl-5a92426cb730d159461ab1079bbfa200.svg";